/* TM Pet Store — product.js (loaded on product pages only) */
(() => {
  'use strict';

  const theme = (window.theme = window.theme || {});
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const debounce = (fn, wait = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  // Money formatting (mirrors Shopify money formats, e.g. "Rs.{{amount}}")
  theme.formatMoney = theme.formatMoney || ((cents, format = theme.moneyFormat || '{{amount}}') => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const delimit = (value, precision = 2, thousands = ',', decimal = '.') => {
      if (value == null || isNaN(value)) return '0';
      const [whole, fraction] = (value / 100).toFixed(precision).split('.');
      return whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`) + (fraction ? decimal + fraction : '');
    };
    const formats = {
      amount: () => delimit(cents, 2),
      amount_no_decimals: () => delimit(cents, 0),
      amount_with_comma_separator: () => delimit(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => delimit(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => delimit(cents, 2, "'", '.'),
      amount_no_decimals_with_space_separator: () => delimit(cents, 0, ' ', '.'),
      amount_with_space_separator: () => delimit(cents, 2, ' ', ','),
      amount_with_period_and_space_separator: () => delimit(cents, 2, ' ', '.')
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (formats[key] || formats.amount)());
  });

  /* Product page: variants, gallery, sticky add to cart */
  $$('[data-product-section]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const product = data.product;
    const form = $('[data-product-form]', section);
    const idInput = form && $('[data-variant-input]', form);
    const picker = $('[data-variant-picker]', section);
    const track = $('[data-gallery-track]', section);
    const thumbs = $$('[data-thumb]', section);
    const sticky = $('[data-sticky-atc]', section);
    const addButtons = $$('[data-add-button]', section);
    const stock = $('[data-stock-status]', section);

    const priceHTML = (variant, large) => {
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      let html = `<div class="price${large ? ' price--lg' : ''}${onSale ? ' price--on-sale' : ''}${variant.available ? '' : ' price--sold-out'}" data-price>`;
      html += `<span class="price__current">${theme.formatMoney(variant.price)}</span>`;
      if (onSale) {
        const pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        html += `<s class="price__compare">${theme.formatMoney(variant.compare_at_price)}</s>`;
        if (pct > 0) html += `<span class="price__chip">${data.strings.percentOff.replace('__pct__', pct)}</span>`;
      }
      return `${html}</div>`;
    };

    /* Gallery */
    const slides = track ? $$('.gallery__slide', track) : [];
    const goTo = (index) => {
      if (!track || !slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    };
    const currentIndex = () => (track ? Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) : 0);
    const syncThumbs = () => {
      const i = currentIndex();
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    };
    if (track) {
      track.addEventListener('scroll', debounce(syncThumbs, 80), { passive: true });
      const prev = $('[data-gallery-prev]', section);
      const next = $('[data-gallery-next]', section);
      if (prev) prev.addEventListener('click', () => goTo(Math.max(0, currentIndex() - 1)));
      if (next) next.addEventListener('click', () => goTo(Math.min(slides.length - 1, currentIndex() + 1)));
      thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => {
          const i = slides.findIndex((s) => s.dataset.mediaId === thumb.dataset.thumb);
          goTo(i);
        })
      );
      // Start on the selected variant's image.
      const active = thumbs.findIndex((t) => t.classList.contains('is-active'));
      if (active > 0) requestAnimationFrame(() => (track.scrollLeft = slides[active].offsetLeft));
    }

    /* Variants */
    const setButtons = (variant) => {
      addButtons.forEach((btn) => {
        const label = $('[data-add-label]', btn);
        btn.disabled = !variant || !variant.available;
        if (label) label.textContent = !variant ? theme.strings.unavailable : variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      });
    };

    const setStock = (variant) => {
      if (!stock) return;
      if (!variant || !variant.available) {
        stock.innerHTML = `<span class="dot dot--out"></span>${data.strings.soldOut}`;
        return;
      }
      const qty = data.inventory[variant.id];
      if (qty !== null && qty !== undefined && qty > 0 && qty <= data.lowStock) {
        stock.innerHTML = `<span class="dot dot--warn"></span>${data.strings.lowStock.replace('__count__', qty)}`;
      } else {
        stock.innerHTML = `<span class="dot dot--ok"></span>${data.strings.inStock}`;
      }
    };

    const refreshAvailability = (selected) => {
      $$('.variant-picker__option', picker).forEach((fieldset, optionIndex) => {
        $$('input', fieldset).forEach((input) => {
          const candidate = selected.slice();
          candidate[optionIndex] = input.value;
          const match = product.variants.find((v) => v.options.every((o, i) => o === candidate[i]));
          const label = $(`label[for="${input.id}"]`, fieldset);
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    };

    const onVariantChange = () => {
      const fieldsets = $$('.variant-picker__option', picker);
      const selected = fieldsets.map((fs) => {
        const checked = $('input:checked', fs);
        const label = $('[data-option-label]', fs);
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
      const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
      refreshAvailability(selected);
      setButtons(variant);
      setStock(variant);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      const priceWrap = $('[data-product-price]', section);
      if (priceWrap) priceWrap.innerHTML = priceHTML(variant, true);
      const stickyPrice = $('[data-sticky-price]', section);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(variant, false);

      if (variant.featured_media) {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (i > -1) goTo(i);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    if (picker) {
      picker.addEventListener('change', onVariantChange);
      refreshAvailability($$('.variant-picker__option', picker).map((fs) => ($('input:checked', fs) || {}).value));
    }

    /* Sticky add to cart */
    const mainButton = $('[data-main-add-button]', section);
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      const stickyBtn = $('[data-sticky-button]', sticky);
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('has-sticky-atc', show);
      }).observe(mainButton);
    }
  });

  /* Product recommendations (lazy, Section Rendering API) */
  $$('[data-recommendations]').forEach((el) => {
    const load = async () => {
      try {
        const res = await fetch(el.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (err) {
        /* recommendations are optional */
      }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          io.disconnect();
          load();
        }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  });
})();
